import { StateUtils } from '@spartacus/core';
import { FAMILIES } from '../custom-families-state';

export enum CustomFamiliesActionTypes {
  LOAD_FAMILIES = '[Families] Load Families',
  LOAD_FAMILIES_SUCCESS = '[Families] Load Families Success',
  LOAD_FAMILIES_FAIL = '[Families] Load Families Fail'
}

export class LoadFamilies {
  readonly type = CustomFamiliesActionTypes.LOAD_FAMILIES;

  constructor(public payload: { code: string; professional?: boolean }) {}
}

export class LoadFamiliesFail extends StateUtils.LoaderFailAction {
  readonly type = CustomFamiliesActionTypes.LOAD_FAMILIES_FAIL;

  constructor(public payload: { error: any }) {
    super(FAMILIES, payload.error);
  }
}

export class LoadFamiliesSuccess {
  readonly type = CustomFamiliesActionTypes.LOAD_FAMILIES_SUCCESS;
  constructor(public payload: any[]) {}
}

// action types
export type CustomFamiliesListActions = LoadFamilies | LoadFamiliesFail | LoadFamiliesSuccess;
